
import React from 'react';

import ReactDOM from 'react-dom/client';

import './styles/global.css'; // Aura Design System tokens (cargar antes que index.css)

import './index.css';

import './i18n'; // i18n must be imported before App

import App from './App';

import reportWebVitals from './reportWebVitals';



// Cache bust: Force browser to download new version
window.__APP_VERSION__ = '2025-11-07-19:20';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

  <React.StrictMode>

    <App />

  </React.StrictMode>

);



// If you want to start measuring performance in your app, pass a function

// to log results (for example: reportWebVitals(console.log))

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();

// Build timestamp: 2025-11-07 19:20

